// FAQ page for projects kept on the v3 experience because they are instrumented
// via an integration partner (e.g. VAPI) that has not upgraded to OTEL
// ingestion yet. The partner performs the upgrade for them; until then the v4
// migration prompts do not apply. Update the slug once the docs page ships.
export const PARTNER_INTEGRATION_FAQ_URL =
  "https://langfuse.com/faq/all/partner-integration-v4-upgrade";
